/**
 * ImageUploadModal Constants
 * Default configuration values for the image upload modal
 */

/** Default maximum file size in megabytes */
export const DEFAULT_MAX_FILE_SIZE_MB = 20;

/** Default accepted MIME types */
export const DEFAULT_ACCEPTED_FORMATS = [
  'image/png',
  'image/jpeg', 
  'image/jpg',
  'application/pdf'
];

/** File extension to MIME type mapping */
export const EXTENSION_TO_MIME: Record<string, string> = {
  '.png': 'image/png',
  '.jpg': 'image/jpeg',
  '.jpeg': 'image/jpeg',
  '.pdf': 'application/pdf',
};

/** Accept attribute for file input */
export const DEFAULT_ACCEPT_ATTRIBUTE = '.png,.jpeg,.jpg,.pdf';

/** Maximum file name length for display */
export const MAX_NAME_DISPLAY_LENGTH = 150;

/** Bytes to MB conversion */
export const BYTES_TO_MB = 1024 * 1024;
